/**
 * Initialize screen tabs store data
 * @param {InitializeScreenTabsPayload} payload - contains screen tabs common props and current selected tab index
 */
export var initializeScreenTabs = function initializeScreenTabs(_ref) {
  var tabs = _ref.tabs,
    selected = _ref.selected;
  return function (_ref2) {
    var getState = _ref2.getState,
      setState = _ref2.setState;
    var _getState = getState(),
      internalScreenTabs = _getState.screenTabs;
    var previouslySelected = internalScreenTabs === null || internalScreenTabs === void 0 ? void 0 : internalScreenTabs.findIndex(function (tab) {
      return tab.isActive;
    });
    setState({
      screenTabs: tabs.map(function (_ref3, index) {
        var id = _ref3.id;
        return {
          id: id,
          isVisible: true,
          isActive: index === selected || index === previouslySelected
        };
      })
    });
  };
};